import { render, staticRenderFns } from "./BannerSDC.vue?vue&type=template&id=00b55bec&scoped=true"
import script from "./BannerSDC.vue?vue&type=script&lang=js"
export * from "./BannerSDC.vue?vue&type=script&lang=js"
import style0 from "./BannerSDC.vue?vue&type=style&index=0&id=00b55bec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00b55bec",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ButtonComponent: require('/home/luiz/Sistemas/loja/components/ButtonComponent.vue').default})
